// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JThk3","switcherWrapper":"styles_switcherWrapper__GV0ku","switcherWrapper__compact":"styles_switcherWrapper__compact__eOhDE"};